import { apiClient } from "@/api/apiClient";

export const fetchEstateByIdAsync = (estateId: number) =>
  apiClient().get(`/estates/${estateId}`);
